import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ggi-31",
  "use": "icon-ggi-31-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ggi-31\">\n<path d=\"M5 19L12 12\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M19 6L19 11.5C19 15.0899 16.0899 18 12.5 18C8.91015 18 6 15.0899 6 11.5C6 7.91015 8.91015 5 12.5 5L18 5C18.5523 5 19 5.44772 19 6Z\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol